import { DropdownReducerActionTypes } from '../types/DropdownReducerActionTypes';
/**
 * An action dispatchable to DropdownReducer.
 * Fire when a dropdown option is selected. This can be accomplised by either the keyboard or mouse
 *
 * @param {DropdownOption} selectedDropdownOption
 * @return {DropdownReducerAction}
 */
export var selectDropdownOptionAction = function (selectedDropdownOption) { return ({
    type: DropdownReducerActionTypes.SelectOption,
    payload: {
        selectedDropdownOption: selectedDropdownOption,
    },
}); };
//# sourceMappingURL=selectDropdownOptionAction.js.map